<template>
  <div
    class="convention-hall page"
    style="width: 100%; background: url(/img/home/g.f7e76bcc.png) repeat top / 100% auto;"
  >
    <van-nav-bar class="nav-bar" :title="$t('auth.top4')">
      <template #left>
        <van-icon
          name="arrow-left"
          size="22"
          color="#000"
          @click="onClickLeft()"
        />
      </template>
    </van-nav-bar>

    <div style="padding-bottom: 80px; background-color: unset;">
      <van-tabs
        v-model="active"
        title-active-color="#C571CF"
        line-height="6px"
        line-width="31px"
        @change="onChange"
      >
        <van-tab
          :title="item.name"
          v-for="(item, index) in tabList"
          :key="index"
          @click="myli(item.id)"
        >
          <van-list v-model="loading" @load="onLoad">
            <!-- 网格卡片布局 -->
            <div class="card-grid" v-show="!isShow">
              <div
                class="card-item"
                v-for="item in data"
                :key="item.id"
                @click="toDetail(item.id)"
              >
                <!-- 图片区域 -->
                <div class="card-img-box">
                  <img :src="item.img_url" class="card-img" />

                  <!-- 编号标签（左上角） -->
                  <div class="id-badge">{{ item.xuanfei_name }}</div>

                  <!-- 底部半透明信息遮罩层 -->
                  <div class="card-info-overlay">
                    <div class="info-top">
                      <!-- 评分（在 location-tag 左侧） -->
                      <div class="rating">
                        <span class="heart-icon">❤</span>
                        <span class="score">10.0</span>
                      </div>
                      
                      <!-- 距离标签（右上角） -->
                      <span class="location-tag">
                        <img src="/img/home/dingwei1.png" class="loc-icon" />
                        {{ item.class_name }}
                      </span>
                    </div>
                    <div class="info-bottom">
                      <!-- 左侧认证标签 -->
                      <div class="verified-badge">
                        {{ $t("index.recmonmand") }}
                      </div>
                      <!-- 右侧认证标签 -->
                      <div class="verified-badge">
                        {{ $t("index.authentication") }}
                      </div>
                    </div>
                    
                    <!-- 评分星星（在 info-bottom 下方） -->
<div class="stars-row">
<div style="width: 100%;"><div style="display: flex; align-items: center;padding: 0px 0px 4px 0px;">
              <van-rate v-model="item.number" color="#ffd21e" size="20px" />
            </div></div>
                    </div>
                  </div>
                </div>

                <!-- 预约按钮 -->
                <div class="appointment-btn">
                  {{ $t("concubine.appointment") }}
                </div>
              </div>
            </div>
          </van-list>
        </van-tab>
      </van-tabs>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      addlist: [],
      isShow: false,
      banners: [{}],
      basicData: [],
      active: 0,
      tabList: [],
      data: [],
      page: 0,
      ids: 1,
      tagTypes: ["primary", "success", "danger", "warning"],
      bannerSwiperOption: {
        effect: "coverflow",
        grabCursor: true,
        centeredSlides: true,
        slidesPerView: "auto",
        speed: 800,
        autoplay: true,
        page: 0,
        coverflowEffect: {
          rotate: 50,
          stretch: 10,
          depth: 100,
          modifier: 1,
          slideShadows: true,
        },
      },
    };
  },
  methods: {
    getxuanfeilist() {
      this.$http({
        method: "get",
        url: "xuanfeilist1",
        data: { id: this.ids, home_class: 1, page: this.page },
      }).then((res) => {
        this.data = res.data;
        this.loading = false;
        const lanng = localStorage.getItem("lang") || "ja";
        this.data.forEach((item) => {
          const parts = item.flag.split("|");
          lanng == "zh"
            ? (item.flag = parts[0])
            : lanng == "en"
            ? (item.flag = parts[1])
            : lanng == "ja"
            ? (item.flag = parts[2])
            : (item.flag = parts[3]);
          item.flagArray = item.flag.split("，");
        });
      });
    },
    onLoad() {},
    toDetail(id) {
      this.$router.push({ path: "/detail", query: { id: id } });
    },
    onClickLeft() {
      this.$router.go(-1);
    },
    getAddress() {
      this.$http({
        method: "get",
        url: "address_list",
      }).then((res) => {
        this.tabList = res.data;
      });
    },
    myli(id) {
      this.ids = id;
      this.getxuanfeilist();
    },
    onChange(index) {
      this.ids = this.tabList[index].id;
      this.loading = true;
      this.data = {};
      this.getxuanfeilist();
    },
    getBasicConfig() {
      this.$http({
        method: "get",
        url: "sys_config",
      }).then((res) => {
        this.basicData = res.data;
        this.getBanner(this.basicData);
      });
    },
    getBanner(data) {
      this.banners = data.banners;
    },
  },
  created() {
    this.getAddress();
    this.getBasicConfig();
    this.getxuanfeilist();
  },
};
</script>

<style lang="less" scoped>
.page {
  position: absolute !important;
}

.nav-bar {
  background: unset;
  height: 100px;
}

.van-nav-bar {
  line-height: 50px;
}

::v-deep .van-nav-bar__title {
  max-width: 60%;
  margin: 0 auto;
  color: #000;
  font-size: 35px;
}

::v-deep .van-nav-bar__content {
  height: 100px;
}

.van-sidebar {
  width: 180px;
}

.convention-hall {
  display: flex;
  flex-direction: column;
  bottom: 20px;
  background: url(/img/home/g.f7e76bcc.png) repeat top / 100% auto;
}

::v-deep .van-tab {
  font-size: 30px;
  line-height: 100px;
  font-weight: bold;
  flex: 1 0 auto;
}

::v-deep .van-tabs__line {
  background-color: unset;
}

::v-deep .van-tabs--line .van-tabs__wrap {
  height: 100px;
}

::v-deep .van-tabs__wrap--scrollable .van-tab {
  padding: 0 23px;
}

::v-deep .van-row--flex {
  height: 80px;
  line-height: 80px;
}

/deep/ .van-tabs__nav {
  background: unset;
}

/deep/ .van-cell {
  padding: 30px 22px;
  font-size: 30px;
  line-height: 30px;
}

/* ========================================= */
/* 网格卡片布局 - 参照截图样式                */
/* ========================================= */
.card-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 12PX;
  padding: 10PX 5PX;
}

.card-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  cursor: pointer;
  border-radius: 12PX;
  overflow: hidden;
  background: #fff;
  box-shadow: 0 4PX 8PX rgba(0,0,0,0.1);
}

.card-img-box {
  position: relative;
  width: 100%;
  aspect-ratio: 3 / 4;
  overflow: hidden;
}

.card-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

/* 编号标签（左上角） */
.id-badge {
  position: absolute;
  top: 8px;
  left: 8px;
  background: rgba(0, 0, 0, 0.6);
  color: #fff;
  font-size: 12PX;
  font-weight: bold;
  padding: 4PX 10PX;
  border-radius: 4PX;
  z-index: 10;
}

/* 底部半透明信息遮罩 */
.card-info-overlay {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  padding: 8PX 10PX;
  background: linear-gradient(to top, rgba(0,0,0,0.8) 0%, rgba(0,0,0,0) 100%);
  color: #fff;
  display: flex;
  flex-direction: column;
}

.info-top {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 4PX;
}

.rating {
  display: flex;
  align-items: center;
  gap: 4PX;
}

.heart-icon {
  color: #ff4d6d;
  font-size: 14PX;
}

.score {
  font-weight: bold;
  font-size: 13PX;
  color: #ffd21e;
  text-shadow: 0 1PX 2PX rgba(0, 0, 0, 0.5);
}

.location-tag {
  display: flex;
  align-items: center;
  gap: 4PX;
  background: #eab977;
  color: #333;
  font-size: 10PX;
  font-weight: 700;
  padding: 2PX 10PX;
  border-radius: 20PX;
}

.location-tag .loc-icon {
  width: 14PX;
  height: 14PX;
  vertical-align: middle;
  display: block;
}

.info-bottom {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.verified-badge {
  font-size: 9PX;
  color: #fff;
  background: rgba(255, 255, 255, 0.2);
  padding: 1PX 8PX;
  border-radius: 10PX;
  font-weight: 500;
  text-shadow: 0 1PX 2PX rgba(0,0,0,0.3);
  letter-spacing: 0.5PX;
}

/* 评分星星行（在 info-bottom 下方） */
.stars-row {
  padding: 4PX 0 2PX;
  display: flex;
  justify-content: center;
}

/* 预约按钮（宽度100%） */
.appointment-btn {
  width: 100%;
  background: linear-gradient(90deg, #fa6ba6, #f32879);
  color: #fff;
  border-radius: 20PX;
  padding: 8PX 0;
  text-align: center;
  font-size: 14PX;
  font-weight: bold;
}
</style>